import { Injectable } from '@angular/core';

import { LocalStoreService } from '@frontend/vanilla/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class UpsellSettingsService {
    private readonly seeLessSettingKey = 'BetslipUpsellIsVisible';

    private readonly upsellVisibility = new BehaviorSubject<boolean>(true);

    get upsellVisibility$(): Observable<boolean> {
        return this.upsellVisibility.asObservable();
    }

    constructor(private localStoreService: LocalStoreService) {
        const showLess = this.localStoreService.get<boolean>(this.seeLessSettingKey) ?? true;
        this.upsellVisibility.next(showLess);
    }

    setUpsellVisibility(isSeeLessEnabled: boolean): void {
        this.localStoreService.set(this.seeLessSettingKey, isSeeLessEnabled);
        this.upsellVisibility.next(isSeeLessEnabled);
    }
}
